import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

export default function StepOneForm({ onNext, initialData }) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
  });

  useEffect(() => {
    if (initialData) {
      setFormData({
        name: initialData.name || "",
        email: initialData.email || "",
        phone: initialData.phone || "",
      });
    }
  }, [initialData]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.name || !formData.email || !formData.phone) {
      alert("Please fill in all fields.");
      return;
    }

    // Send Step1 data only
    onNext(formData);
  };

  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100">
      <div className="card shadow-lg" style={{ maxWidth: "650px", width: "100%", borderRadius: "2rem", overflow: "hidden", background: "rgba(255,255,255,0.95)", backdropFilter: "blur(12px)" }}>
        <h3 className="text-center text-white p-4" style={{ background: "#009494" }}>Step 1: Tell us about yourself</h3>
        <div className="p-4">
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="form-label fw-semibold">Full Name</label>
              <input
                type="text"
                name="name"
                className="form-control form-control-lg"
                placeholder="Enter your full name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="mb-4">
              <label className="form-label fw-semibold">Email</label>
              <input
                type="email"
                name="email"
                className="form-control form-control-lg"
                placeholder="Enter your email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="mb-4">
              <label className="form-label fw-semibold">Phone</label>
              <input
                type="tel"
                name="phone"
                className="form-control form-control-lg"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>


            <button type="submit" className="btn w-100 py-3" style={{ background: "#009494", color: "white" }}>Next →</button>
          </form>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(15px); }
          to { opacity: 1; transform: translateY(0); }
        }
          .form-control {
  font-size: 1.5rem !important;
}

          
      `}</style>
    </div>
  );
}
